import type { DefaultValues } from "react-hook-form"

import type { TTranslationKeys } from "$/i18n/i18n"

import { JS_CONF } from "@/constants"

import { type TAuthContainerMode, type TAuthFormValues } from "./auth.ui.types"

const titlesMap: { [M in TAuthContainerMode]: keyof TTranslationKeys } = {
    register: "auth.registerOrLoginPage.title",
    login: "auth.registerOrLoginPage.title",
    reset: "auth.resetPasswordPage.title"
}

const butonLabelsMap: { [M in TAuthContainerMode]: keyof TTranslationKeys } = {
    register: "auth.registerPage.submit",
    login: "auth.loginPage.submit",
    reset: "auth.resetPasswordPage.submit"
}

const formDefaultValues: { [key in TAuthContainerMode]: DefaultValues<TAuthFormValues> } = {
    register: { email: JS_CONF?.email || String(""), password: String(""), confirmPassword: String("") },
    login: { email: String(""), password: String("") },
    reset: { password: String(""), confirmPassword: String("") }
}

const config = { titlesMap, butonLabelsMap, formDefaultValues }

export { config as authUiConfig }
